
import { Component, Emit, Prop, Vue, Watch } from 'vue-property-decorator';
import moment from 'moment';

@Component
export default class VDateRangePicker extends Vue {
  @Prop({ type: Boolean, default: true }) public required!: boolean;
  @Prop({ type: [Object, String], default: () => null }) public value!: { from: string; to: string } | string;
  @Prop({ type: String, default: '' }) public hint!: string;
  @Prop({ type: [Array, Function] }) public allowedDates!: any[] | ((date?: any) => void);
  @Prop({ type: Number }) public maxRange!: number;
  @Prop({ type: Boolean, default: false }) public hideEnd!: boolean;
  @Prop({ type: Boolean, default: false }) public startOptional!: boolean;
  @Prop({ type: Boolean, default: false }) public endOptional!: boolean;

  public from: string = '';
  public fromMenu: boolean = false;
  public to: string = '';
  public toMenu: boolean = false;

  get range() {
    if (
      this.startOptional ? this.to?.length : this.endOptional ? this.from?.length : this.from?.length && this.to?.length
    ) {
      return {
        from: this.from,
        to: this.to,
      };
    }

    return null;
  }

  get fromAllowedDates() {
    return (date: string) => {
      const isAllowed = typeof this.allowedDates === 'function' ? this.allowedDates(date) : true;

      if (this.to && this.maxRange) {
        const maxFromDate = moment(this.to).subtract(this.maxRange, 'days');

        return (
          isAllowed && moment(date).isSameOrAfter(maxFromDate, 'day') && moment(date).isSameOrBefore(this.to, 'day')
        );
      }

      return isAllowed;
    };
  }

  get toAllowedDates() {
    return (date: string) => {
      const isAllowed = typeof this.allowedDates === 'function' ? this.allowedDates(date) : true;

      if (this.from && this.maxRange) {
        const maxToDate = moment(this.from).add(this.maxRange, 'days');

        return (
          isAllowed && moment(date).isSameOrAfter(this.from, 'day') && moment(date).isSameOrBefore(maxToDate, 'day')
        );
      }

      return isAllowed;
    };
  }

  public mounted() {
    this.init();
  }

  public init() {
    if (typeof this.value === 'string') {
      return;
    }

    if (this.value?.from) {
      this.from = moment(this.value.from).format('YYYY-MM-DD');
    }

    if (this.value?.to) {
      this.to = moment(this.value.to).format('YYYY-MM-DD');
    }
  }

  get fromRules() {
    if (!this.required || this.startOptional) {
      return 'date_before:@to';
    }

    return 'required|date_before:@to';
  }

  get toRules() {
    if (!this.required || this.endOptional || this.hideEnd) {
      return '';
    }

    return 'required';
  }

  @Watch('value')
  public onValueChange(val: Range, oldVal: Range) {
    if (val !== oldVal) {
      this.init();
    }
  }

  @Watch('range')
  @Emit('input')
  public onRangeChange() {
    return this.range;
  }
}
